import { HTTPAPI } from "./base";
import * as qs from 'qs';


const grabToken = () => {
    const uInfoTxt = localStorage.getItem("userInfo");    
    let uInfo = null;
    if(uInfoTxt) {
        uInfo = JSON.parse(uInfoTxt);
    }
    const token = uInfo != null ? uInfo.token : "";    
    return token;
}

function composePath(path, urlParams=null, routeParams=null) {
    if(routeParams) {
        for(let key of Object.keys(routeParams)) {
            path = path.replace(key, routeParams[key]);
        }
    }    
    let finalPath = "/" + path;
    if(urlParams) {
        if(typeof urlParams === 'string') {
            finalPath += "?" + encodeURIComponent(urlParams);
        }
        else {
            finalPath += "?" + encodeURIComponent(qs.stringify(urlParams));
        }        
    }     
    return finalPath;
}

export const srvApi = {
    get: (path, urlParams=null, routeParams=null) => {                
        return HTTPAPI(grabToken())
        .get(composePath(path, urlParams, routeParams));
    },
    post: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .post(composePath(path, urlParams, routeParams), data);
    },
    put: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .put(composePath(path, urlParams, routeParams), data);
    },
    patch: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .patch(composePath(path, urlParams, routeParams), data);
    },
    delete: (path, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .delete(composePath(path, urlParams, routeParams));
    },
    postfile: (path, data, onUploadProgress=null, urlParams=null, routeParams=null) => {        
        return HTTPAPI(grabToken())
        .post(
            composePath(path, urlParams, routeParams), 
            data,
            {
                headers: {
                  "Content-Type": "multipart/form-data"
                },
                onUploadProgress
            }
        );
    },
}

export const srvApiNoAuth = {
    get: (path, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .get(composePath(path, urlParams, routeParams));
    },
    post: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .post(composePath(path, urlParams, routeParams), data);
    },
    put: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .put(composePath(path, urlParams, routeParams), data);
    },
    patch: (path, data, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .patch(composePath(path, urlParams, routeParams), data);
    },
    delete: (path, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .delete(composePath(path, urlParams, routeParams));
    },
    postfile: (path, data, onUploadProgress=null, urlParams=null, routeParams=null) => {        
        return HTTPAPI()
        .post(
            composePath(path, urlParams, routeParams), 
            data,
            {
                headers: {
                  "Content-Type": "multipart/form-data"
                },
                onUploadProgress
            }
        );
    },
}

export const PATH = {
    ASSIGNMENT_BATCH: "assignment/batch",
    ASSIGNMENT_MANUALASSIGNTECH: "assignment/manualassigntech",
    ASSIGNMENT_RESETBATCH: "assignment/resetbatch",
    ASSIGNMENT_SETTIME: "assignment/settime",
    ASSIGNMENT_SETPOSITION: "assignment/setposition",
    ASSIGNMENT_AUTOCALC: "assignment/autocalc",
    ASSIGNMENT_PREVIEWRESULT: "assignment/previewresult",
    ASSIGNMENT_PUBLISHBATCH: "assignment/releasebatchtotechnicians",
    ASSIGNMENT_RELEASEBATCH : "assignment/releasebatchassignments",
    ASSIGNMENT_UNDORELEASEBATCH : "assignment/undoreleasebatchassignments",
    ASSIGNMENT_REMOVE: "assignment/remove",
    ASSIGNMENT_EXCLUDETECHNICIAN: "assignment/excludetechnician",
    ASSIGNMENT_INCLUDETECHNICIAN: "assignment/includetechnician",
    ASSIGNMENT_APPOINTMENT: "assignment/appointment",
    // PROFILE_MY: "profile/my",
    // PROFILE_MYTHERAPIST: "profile/mytherapist",
    // UPLOADS_UPLOAD: "uploads/uploadasset",
    // UPLOADS_UPLOADPROFILEPIC: "uploads/uploadprofilepic",
    // BOOKING_THERAPISTS: "booking/therapists",
    // BOOKING_THERAPIST: "booking/therapist",
}

export const getAssetUrl = function(fileid, thumbnailOrParams) {
    //https://adminpanel.massageapp.gr/assets/c38adf71-f8b7-4a17-b377-36abcc634fc7
    //api/assets/
    let url = "/api/assets/" + fileid; // + "/" + fileid + ".png";
    if(thumbnailOrParams) {
        if(thumbnailOrParams.toString() == "true") {
            url += "";
        }
        else {
            url += thumbnailOrParams
        }
    }    
    return url; 
};